/** MatchHub ? gameRoomId ??? long / int??????????invoke ???? */
export function parseHubGameRoomId(roomId: string | number): number {
  const parsed = typeof roomId === 'number' ? roomId : Number(roomId);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    throw new Error(`Invalid gameRoomId: ${roomId}`);
  }
  return parsed;
}

/** SendTrade payload??? GameRoomId ???????? TradeData */
export function normalizeSendTradePayload(payload: unknown): Record<string, unknown> {
  if (!payload || typeof payload !== 'object') {
    throw new Error('SendTrade payload must be an object');
  }

  const raw = payload as Record<string, unknown>;
  const roomId = raw.GameRoomId ?? raw.gameRoomId;
  const gameRoomId = parseHubGameRoomId(roomId as string | number);

  return {
    ...raw,
    GameRoomId: gameRoomId,
  };
}
